<template>
  <div class="v-mentionable-overlay v-mentionable-overlay--readonly">
    <template v-for="(item, index) in value" :key="index">
      <a v-if="'key' in item && item.key in mentions" class="v-mention">
        <slot :mention="mentions[item.key]" name="mention">{{ item.text }}</slot>
      </a>
      <template v-else>{{ item.text }}</template>
    </template>
  </div>
</template>

<script setup lang="ts" generic="TMention extends Mention">
import { computed } from 'vue'

import { type Mention, type ModelValue } from './VMentionable.vue'

interface Props {
  value: ModelValue
  options: TMention[]
  triggerKey?: string
}

const props = withDefaults(defineProps<Props>(), {
  triggerKey: '@',
})

defineSlots<{
  mention?(props: { mention: TMention }): any
}>()

type Mentions = Record<string | number, TMention>
const mentions = computed((): Mentions => {
  const mentions: Mentions = {}
  const text = props.value.map((part) => part.text).join('')

  for (const option of props.options) {
    if (option.key in mentions) {
      continue
    }

    const regex = new RegExp(`(\\s|^)${props.triggerKey}${option.label}(?=\\s|\\b|$)`, 'gm')
    if (regex.test(text)) {
      mentions[option.key] = option
    }
  }

  return mentions
})
</script>

<style>
.v-mentionable-overlay--readonly {
  display: inline-block;
}
</style>
